module.exports = __webpack_public_path__ + "img/woocommerce.97748ff8.jpg";